var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import classNames from "classnames";
import { useField, useFormikContext } from "formik";
import React from "react";
import { getTooltipText } from "../../../modules/generator/generator-tooltips";
export var FormItemRadio = function (_a) {
    var name = _a.name, label = _a.label, options = _a.options, tooltip = _a.tooltip, tooltips = _a.tooltips, rest = __rest(_a, ["name", "label", "options", "tooltip", "tooltips"]);
    var _b = useFormikContext(), submitForm = _b.submitForm, setFieldValue = _b.setFieldValue;
    var _c = __read(useField(name), 2), field = _c[0], meta = _c[1];
    var touched = meta.touched, error = meta.error;
    var selectedValue = field.value;
    var errorText = touched && error ? error : null;
    var handleChange = function (e) {
        setFieldValue(name, e.currentTarget.value);
    };
    return (React.createElement("div", { className: "form-item-radio" },
        React.createElement("div", { className: "form-item-radio__legend_box" },
            React.createElement("label", { className: "form-item-radio__legend" }, label),
            tooltip ? (React.createElement("div", { className: "form-item-box__tooltip" },
                "i",
                React.createElement("div", { className: "form-item-box__tooltip_window tooltip" }, tooltip))) : (React.createElement(React.Fragment, null))),
        React.createElement("div", { className: "form-item-radio__items" }, options.map(function (_a) {
            var value = _a.value, label = _a.label;
            return (React.createElement("div", { className: "form-item-radio__item_box " + value },
                getTooltipText(tooltips, value) ? (React.createElement("div", { className: "form-item-radio__tooltip" },
                    "i",
                    React.createElement("div", { className: "form-item-radio__tooltip_window" }, getTooltipText(tooltips, value)))) : (React.createElement(React.Fragment, null)),
                React.createElement("div", { className: "form-item-radio__item" },
                    React.createElement("label", { htmlFor: name + "_" + value, className: classNames("form-item-radio__label", {
                            "form-item-radio__label--selected": value === selectedValue,
                        }) }, label),
                    React.createElement("input", { id: name + "_" + value, className: "form-item-radio__control", type: "radio", name: name, value: value, onChange: handleChange }))));
        })),
        errorText && (React.createElement("div", { className: "form-item-radio__error scroll_to_error" }, errorText))));
};
